import "./register.css"
import { Link } from "react-router-dom"
import { useState } from "react";
// import axios from "axios";
import { axiosInstance } from "../../config";

export default function Register() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(false);
    try{
    const res = await axiosInstance.post("/auth/register", {
      username, email, password
    });
    res.data && window.location.replace("/login");
  }catch (err){
    setError(true);
  }}

    return (
        <div className="register">
      <span className="registerTitle">Register</span>
      <form className="registerForm" onSubmit={handleSubmit}>
        <label>USERNAME</label>
        <input className="registerInput" type="text" placeholder="Enter your username" onChange={(e) => setUsername(e.target.value)}/>
        <label>EMAIL</label>
        <input className="registerInput" type="text" placeholder="Enter your email" onChange={(e) => setEmail(e.target.value)}/>
        <label>PASSWORD</label>
        <input className="registerInput" type="password" placeholder="Enter your password" onChange={(e) => setPassword(e.target.value)}/>
        <button className="registerButton" type="submit">REGISTER</button>
      </form>
        <button className="registerLoginButton">
          <Link className="link" to="/login">LOGIN</Link>

        </button>

        {error && <span style={{color:'red', marginTop:'10px'}}>
          Something went wrong...
        </span>}
    </div>
    )
}